@import '../../utils/tag-chip.css';

/*
 * Semantic state colors — Chip’s differentiator from Tag.
 * All states use the faint contrast weight; hue comes from the state.
 */
:host(.chip--default) {
  background-color: var(--color-background-faint-neutral);
  color: var(--color-foreground-bold-neutral);
}

:host(.chip--active) {
  background-color: var(--color-background-faint-brand);
  color: var(--color-foreground-bold-brand);
}

:host(.chip--error) {
  background-color: var(--color-background-faint-negative);
  color: var(--color-foreground-bold-negative);
}

:host(.chip--caution) {
  background-color: var(--color-background-faint-caution);
  color: var(--color-foreground-bold-caution);
}

/*
 * Label↔dismiss uses host gap, mirroring Tag icon↔label spacing:
 * [inset][text][inset][gap][icon].
 */
.tag__remove {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  color: inherit;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  border-radius: var(--dimension-radius-half);
}

.tag__remove::before {
  content: '';
  position: absolute;
  inset: var(--dimension-space-n025);
  border-radius: var(--dimension-radius-half);
  background-color: transparent;
  transition: var(--effect-transition-interaction-background-short-2);
  pointer-events: none;
}

@media (hover: hover) and (pointer: fine) {
  .tag__remove:hover::before {
    background-color: var(--color-interaction-hover);
  }
}

.tag__remove:active::before {
  background-color: var(--color-interaction-pressed);
}

:host(.tag--size-sm) .tag__remove::before {
  inset: var(--dimension-space-n012);
}

:host(.tag--size-xs) .tag__remove::before {
  inset: 0;
}

.tag__remove-x {
  display: inline-flex;
  flex-shrink: 0;
  width: var(--ds-control-icon);
  height: var(--ds-control-icon);
}
